import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { color as handleColor, HsvaColor } from '../utils/color-convert';

type EyeDropperProps = {
    setHex: (hex: string) => void;
    setHsva: (hsva: HsvaColor) => void;
    handleChange: (hsva: HsvaColor) => void;
};

const EyeDropper = ({ setHex, setHsva, handleChange }: EyeDropperProps) => {
    const systemDraw = async () => {
        try {
            const eyeDropper = new (window as any).EyeDropper() as any;
            const result = await eyeDropper.open(); // 开始拾取颜色
            const colorHexValue = result.sRGBHex;
            const { hex, hsva } = handleColor(colorHexValue);
            setHex(hex.slice(1, 7));
            setHsva(hsva);
            handleChange(hsva);
        } catch (e) {
            console.log('用户取消了取色', e);
        }
    };
    return (
        <div
            className="c-color-sketch-picker__menu--eyeDropper"
            onClick={async () => {
                systemDraw();
            }}
        >
            <IconFont name="DropperBold" fontSize={15} />
        </div>
    );
};

export default EyeDropper;
